import {Axios} from "axios";
import {type ComposerTranslation, type I18n} from "vue-i18n";
import {getInstance} from "@/auth/oauth";
import {watch} from "vue";
import {type Router} from "vue-router";
import {makeErrorToast} from "@/util/toastUtils";

export const interceptHttpResponses = (i18n: I18n<any>, axios: Axios, router: Router) => {
    // @ts-ignore
    const t = i18n.global.t as ComposerTranslation;
    const auth = getInstance();

    axios.interceptors.response.use(
        (data) => {
            return data;
        },
        async (err) => {
            if (err?.response?.status === 401 && auth.isAuthenticated()) {
                await auth.logout();
                throw err;
            }

            makeErrorToast(getErrorMessage(t, err));
            throw err;
        },
    );

    watch([router.currentRoute], (currentRoute) => {
        if (currentRoute.length && currentRoute[0].query.error) {
            makeErrorToast(translateMessage(t, `ERRORS.${currentRoute[0].query.error}`));
        }
    });
};

const getErrorMessage = (t: ComposerTranslation, err: any) => {
    let translationKey: string | null = null;

    if (err?.response) {
        if (err.response.data && typeof err.response.data === "string") {
            translationKey = `ERRORS.${err.response.data}`;
        } else if (err.response.data?.message && typeof err.response.data.message === "string") {
            translationKey = `ERRORS.${err.response.data.message}`;
        } else if (err.response.status === 400) {
            translationKey = "ERRORS.BAD_REQUEST";
        } else if (err.response.status === 401) {
            translationKey = "ERRORS.UNAUTHORIZED";
        } else if (err.response.status === 403) {
            translationKey = "ERRORS.FORBIDDEN";
        }
    }

    return translateMessage(t, translationKey);
};

const translateMessage = (t: ComposerTranslation, translationKey: string | null) => {
    if (translationKey) {
        const translation = t(translationKey);
        if (translationKey !== translation) {
            return translation;
        }
    }

    return t("ERRORS.ERROR_GENERAL");
};
